// extracted by mini-css-extract-plugin
module.exports = {"root":"LoadingAlert_root__2mADE","content":"LoadingAlert_content__toM01"};